import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { canShow } from '@frontend/web/components/SignInGate/displayRule';
import { initPerf } from '@root/src/web/browser/initPerf';
const SignInGateFakeSocial = React.lazy(() => {
    const { start, end } = initPerf('SignInGateFakeSocial');
    start();
    return import(
    /* webpackChunkName: "SignInGateFakeSocial" */ '../gateDesigns/SignInGateFakeSocial').then((module) => {
        end();
        return { default: module.SignInGateFakeSocial };
    });
});
export const signInGateComponent = {
    gate: ({ ophanComponentId, dismissGate, guUrl, signInUrl, abTest, isComment, }) => (React.createElement(Lazy, { margin: 300 },
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement(SignInGateFakeSocial, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment })))),
    canShow,
};
